export const getReportContact = (email, phoneNumber) => {
  if (email && phoneNumber) return `${email}, ${phoneNumber}`;

  if (email) return email;

  if (phoneNumber) return `${phoneNumber}`;

  return '';
};
